var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        ref: "WorkCooperation",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            staticClass: "w-100",
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(
                                                " 本人是否對其他公司負有保密義務？ "
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Do I have a duty of confidentiality to other companies? "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.HasNDA,
                                                  expression: "HasNDA",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.HasNDA,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.HasNDA = true
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.HasNDA,
                                                  expression: "HasNDA",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.HasNDA,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.HasNDA = false
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._l(_vm.confidentiality, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: "Company" + index, staticClass: "col-md-12" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 所負義務對象（與您約定保密義務的公司） "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Company's name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Company,
                                                      expression:
                                                        "item.Company",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Company,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Company",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Content" + index, staticClass: "col-md-12" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c("span", { staticClass: "mark" }, [
                                  _vm._v("*"),
                                ]),
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 請說明保密義務內容 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Description"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("el-input", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "textarea",
                                      rows: 6,
                                      maxlength: "200",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: item.Content,
                                      callback: function ($$v) {
                                        _vm.$set(item, "Content", $$v)
                                      },
                                      expression: "item.Content",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "StartDate" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 保密義務期間（起） "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Time for remaining confidential (Start)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "month",
                                                    "value-format": "yyyy-MM",
                                                    placeholder: "YYYY-MM",
                                                  },
                                                  model: {
                                                    value: item.StartDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "StartDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.StartDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "IsPermanent" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [_vm._v(" 是否永久 ")]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-radio" },
                                              [
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.IsPermanent,
                                                        expression:
                                                          "item.IsPermanent",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: true,
                                                      checked: _vm._q(
                                                        item.IsPermanent,
                                                        true
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "IsPermanent",
                                                          true
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("是 (Yes)"),
                                                  ]),
                                                ]),
                                                _c("label", [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: item.IsPermanent,
                                                        expression:
                                                          "item.IsPermanent",
                                                      },
                                                    ],
                                                    attrs: { type: "radio" },
                                                    domProps: {
                                                      value: false,
                                                      checked: _vm._q(
                                                        item.IsPermanent,
                                                        false
                                                      ),
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.$set(
                                                          item,
                                                          "IsPermanent",
                                                          false
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v("否 (NO)"),
                                                  ]),
                                                ]),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        item.IsPermanent === false
                          ? _c(
                              "div",
                              {
                                key: "EndDate" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "field" },
                                  [
                                    _c("ValidationProvider", {
                                      attrs: {
                                        rules: {
                                          required: true,
                                          notBeforeStartDate: item.StartDate,
                                        },
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-title",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      { staticClass: "mark" },
                                                      [_vm._v("*")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        style: {
                                                          color: _vm.fontColor,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          " 保密義務期間（迄） "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "en-text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Time for remaining confidential (End)"
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "field-value",
                                                  },
                                                  [
                                                    _c("el-date-picker", {
                                                      staticClass: "w-100",
                                                      attrs: {
                                                        type: "month",
                                                        "value-format":
                                                          "yyyy-MM",
                                                        placeholder: "YYYY-MM",
                                                      },
                                                      model: {
                                                        value: item.EndDate,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "EndDate",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.EndDate",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-danger",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(errors[0]) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.confidentiality.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _vm.HasNDA
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-sm add-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveConfidentiality)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }